import React from "react";
import "./PlaceOder.css";
import { useAuth0 } from "@auth0/auth0-react";
function PlaceOrder() {
  const { isAuthenticated, user } = useAuth0();
  return (
    <div className="placeorder">
      <p>
        Hi,
        {isAuthenticated && <span>{user.name}</span>}
      </p>

      <span> Order Placed SuccessFully.</span>
      <div className="placeorder_info">
        <span>Your Order Will Delivered in 3 Days.</span>
        <span className="placeorder_info_confirm">
          We are pleased to confirm your order <br />
          OD113237959885484000.
           Thank you for shopping with Flipkart!
        </span>
      </div>
    </div>
  );
}

export default PlaceOrder;
